import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import OrderDetailRow from './OrderDetailRow';
import { Hidden } from '@mui/material';
import SubAndTotalRow from './SubAndTotalRow';
import { Membership } from 'src/models/membership';
import { format } from 'date-fns';
import { getDollars } from 'src/utils/currency';

interface UpcomingInvoiceProps {
  membership: Membership;
}

export const UpcomingInvoice = ({ membership }: UpcomingInvoiceProps) => {
  const { subscription } = membership;
  const { created, status, provider, currency, price } = subscription;

   const lineItems =
    subscription.nextInvoiceLineItems.length > 0
      ? subscription.nextInvoiceLineItems
      : subscription.lineItems

  const taxes = lineItems.filter(
    (item) => item.lineType === 'sales_tax'
  );
  let subtotal = lineItems.find(
    (item) => item.lineType === 'subtotal'
  );

  let subTypeLines = lineItems.filter(
    (item) =>
      item.lineType === 'product_none_shippable' ||
      item.lineType === 'proration'
  );

  if (provider !== 'stripe') {
    subTypeLines = [
      {
        id: 'l' + subscription.id,
        description: 'Membership',
        currency,
        quantity: 1,
        unitAmount: price,
        lineNumber: 1,
        lineType: 'product_none_shippable',
        refundAmount: 0,
        returnQuantity: 0,
        refundQuantity: 0,
        sku: 'X'
      }
    ];
    subtotal = {
      id: 'l' + subscription.id,
      description: 'Subtotal',
      currency,
      quantity: 0,
      unitAmount: price,
      lineNumber: 2,
      lineType: 'subtotal',
      refundAmount: 0,
      returnQuantity: 0,
      refundQuantity: 0,
      sku: 'SUBTOTAL'
    };
  }

  const contract =
    subscription?.contracts.length > 0 ? subscription.contracts[0] : null;
  let contractDiscount = 0;
  //recalculate the subtotal
  if (subtotal) {
    subtotal.unitAmount = 0;
    for (const li of subTypeLines) {
      let qnty = membership.getPriceQuanty(li);

      subtotal.unitAmount += qnty * membership.getUnitAmount(li);
    }
    if (contract) {
      contractDiscount = subtotal.unitAmount * contract.discountPercent;
      subtotal.unitAmount -= contractDiscount;
    }
  }

  return (
    <>
      <Box sx={{ margin: '2rem 2rem 0 2rem' }}>
        {subscription.isStripe() &&
          !subscription.isTrialPendingHeadsetRegistration() &&
          subscription.status !== 'canceled' && (
            <>
              <Typography
                sx={{
                  fontSize: 14,
                  fontStyle: 'italic',
                  fontWeight: 800,
                  margin: '1rem 0 0.5rem 0'
                }}
                color="textSecondary"
                gutterBottom
              >
                Next Invoice:{' '}
                {subscription.cancelAtPeriodEnd &&
                !subscription.isProfesssional()
                  ? 'canceled'
                  : format(subscription.currentPeriodEnd, 'MM/dd/yyyy')}
              </Typography>
            </>
          )}

        {!subscription.isStripe() && (
          <Typography
            sx={{
              fontSize: 14,
              fontStyle: 'italic',
              fontWeight: 800,
              margin: '1rem 0 0.5rem 0'
            }}
            color="textSecondary"
            gutterBottom
          >
            Estimated Next Invoice:{' '}
            {`${getDollars(
              subscription.price + (subscription.discountAmount ?? 0)
            )} ${subscription.currency.toUpperCase()}`}
            {' on '}
            {subscription.cancelAtPeriodEnd && !subscription.isProfesssional()
              ? 'canceled'
              : format(subscription.currentPeriodEnd, 'MM/dd/yyyy')}
          </Typography>
        )}

        {subscription.cancelAtPeriodEnd && (
          <Box>
            <Typography
              sx={{
                fontSize: 14,
                fontStyle: 'italic',
                fontWeight: 800,
                margin: '1rem 0 0.5rem 0'
              }}
              color="textSecondary"
            >
              Subscription cancellation request has been received. Current
              subscription will remain active until{' '}
              {format(subscription.currentPeriodEnd, 'MM/dd/yyyy')}.{' '}
              {subscription.isProfesssional()
                ? 'This customer will only be charged for any usage exceeding what is included with their plan.'
                : ''}
            </Typography>
          </Box>
        )}
        <Box>
          <Hidden smDown>
            <OrderDetailRow
              desc="Description"
              unitAmount="Amount"
              quantity=""
              unitQuantStr="Total Price"
              currency={subtotal!.currency}
            />
          </Hidden>
          {subTypeLines &&
            subTypeLines.length > 0 &&
            subTypeLines.map((li) => (
              <OrderDetailRow
                key={li.id}
                desc={membership.buildLineItemDescription(li)}
                quantity={membership.getPriceQuanty(li)}
                unitAmount={membership.getUnitAmount(li)}
                currency={li.currency}
                subtext={
                  membership.featureBilling?.length > 0
                    ? membership.buildLineItemSubDescription(li)
                    : ''
                }
                strikeAmt={membership.getPriceQuanty(li) === 0}
              />
            ))}

          {contract && contractDiscount > 0 && (
            <SubAndTotalRow
              desc={contract.description}
              value={contractDiscount * -1}
              currency={subtotal!.currency}
              isTotal={false}
            />
          )}
          <SubAndTotalRow
            key={'total_' + subtotal!.id}
            value={subtotal!.unitAmount}
            currency={subtotal!.currency}
            desc={''}
            isTotal={true}
          />
          {((taxes && taxes.length) || provider !== 'stripe') && (
            <Typography
              color={'#666666'}
              fontStyle={'italic'}
              textAlign={'right'}
              lineHeight={'1rem'}
              fontSize="0.9rem"
            >
              * Plus applicable taxes
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};
